/** @format */

import { SearchOutlined } from "@ant-design/icons";
import { Button, Form, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setStore } from "redux/actions";
import { getMadrasah } from "services/v2/usermanservice/madrasahservices";
import { listOption } from "utils/helper";

type FilterFormProps = {
  loading: boolean;
  handleFilter: (filter: any) => void;
  formLayout?: "inline" | "horizontal" | "vertical";
  // onFilter: (filter: any) => void;
};
export const FilterForm = ({
  loading,
  handleFilter,
  formLayout,
}: FilterFormProps) => {
  const [kodeProvinsi, setKodeProvinsi] = useState<string | null>(null);
  const [kodeKabKota, setKodeKabKota] = useState<string | null>(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { auth, provinsi, kabkota, kodeSumberDana, madrasah } = useSelector(
    (state: any) => ({
      auth: state.auth?.data || null,
      provinsi: state.store?.provinsi,
      kabkota: state.store?.kabkota,
      kodeSumberDana: state.dashboard?.header3 || [],
      madrasah: state.store?.listMadrasah || [],
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (auth?.group_role === "provinsi") {
      form.setFieldsValue({
        provinsi: auth.kode_provinsi,
      });

      setKodeProvinsi(auth.kode_provinsi);
    }

    if (auth?.group_role === "kabkota") {
      form.setFieldsValue({
        kabkota: auth.kode_kabkota,
      });

      setKodeKabKota(auth.kode_kabkota);
    }
  }, [auth, form]);

  const listKabkota = useMemo(() => {
    if (kodeProvinsi) {
      return kabkota.filter((item: any) => item.kode_provinsi === kodeProvinsi);
    }

    if (auth?.kode_provinsi) {
      return kabkota.filter(
        (item: any) => item.kode_provinsi === auth.kode_provinsi,
      );
    }

    return kabkota;
  }, [kabkota, kodeProvinsi, auth]);

  const listMadrasah = useMemo(() => {
    if (kodeKabKota) {
      return madrasah.filter((item: any) => item.kode_kabkota === kodeKabKota);
    }

    if (["provinsi", "kabkota"].includes(auth?.group_role)) {
      return madrasah.filter(
        (item: any) => item.kode_kabkota === auth.kode_kabkota,
      );
    }

    return madrasah;
  }, [madrasah, kodeKabKota, auth]);

  useEffect(() => {
    const getData = async () => {
      let filter = "";

      if (auth?.group_role === "provinsi") {
        filter = `?kodeProvinsi=${auth?.kode_provinsi}`;
      }

      if (auth?.group_role === "kabkota") {
        filter = `?kodeProvinsi=${auth?.kode_provinsi}&kode_kabkota=${auth?.kode_kabkota}`;
      }

      if (madrasah.length === 0) {
        const madrasahTmp = await getMadrasah(filter);

        dispatch(
          setStore({
            listMadrasah: madrasahTmp || [],
          }),
        );
      }
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, dispatch]);

  return (
    <div className="flex-1">
      <Form
        form={form}
        layout={formLayout}
        style={{ maxWidth: formLayout === "inline" ? "none" : 600 }}
        onFinish={(values) => {
          handleFilter(values);
        }}
        onValuesChange={(changedValues) => {
          if ("provinsi" in changedValues) {
            setKodeProvinsi(changedValues.provinsi || null);

            setKodeKabKota(null);

            form.setFieldsValue({
              kabkota: undefined,
              madrasah: undefined,
            });
          }

          if ("kabkota" in changedValues) {
            setKodeKabKota(changedValues.kabkota || null);

            form.setFieldsValue({
              madrasah: undefined,
            });
          }
        }}>
        <Form.Item
          label=""
          name="kodeSumberDana"
          style={{ minWidth: formLayout === "inline" ? 200 : "100%" }}>
          <Select
            mode="multiple"
            placeholder="Sumber Dana"
            allowClear
            optionFilterProp="children"
            options={listOption(
              kodeSumberDana,
              "kodeSumberDana",
              "namaSumberDana",
            )}
          />
        </Form.Item>
        {auth?.group_role === "pusat" && (
          <Form.Item label="" name="provinsi">
            <Select
              showSearch
              placeholder="Provinsi"
              allowClear
              optionFilterProp="children"
              // style={{ width: "80%" }}
              options={listOption(provinsi, "kode", "nama")}
            />
          </Form.Item>
        )}

        {["pusat", "provinsi"].includes(auth?.group_role) && (
          <Form.Item label="" name="kabkota">
            <Select
              showSearch
              allowClear
              optionFilterProp="children"
              placeholder="Kabupaten/Kota"
              // style={{ width: "80%" }}
              options={listOption(listKabkota, "kode", "nama")}
            />
          </Form.Item>
        )}

        {["pusat", "provinsi", "kabkota"].includes(auth?.group_role) && (
          <Form.Item label="" name="madrasah">
            <Select
              showSearch
              allowClear
              optionFilterProp="children"
              placeholder="Madrasah"
              // style={{ width: "80%" }}
              options={listOption(listMadrasah, "nsm", "nama")}
            />
          </Form.Item>
        )}
        <Form.Item>
          <Button
            block={formLayout !== "inline"}
            icon={<SearchOutlined />}
            type="primary"
            // style={{ width: "80%" }}
            loading={loading}
            htmlType="submit">
            Cari
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
